'use strict';

bbw.directive.BbwTabsController = Class({

    EVENT_BBW_TAB_SELECTED: 'bbw-tab-selected',

    $inject: ['$scope', '$timeout'],
    _tabs: undefined,
    _prevSelectedTab: undefined,
    _selectedTab: undefined,
    _activeClass: undefined,
    _defaultSelected: undefined,
    _onTabSelectedFn: undefined,

    construct: function($scope, $timeout) {
        this.$scope = $scope;
        this.$timeout = $timeout;
    },

    setup: function(tabs, activeClass, defaultSelectedName, onTabSelected) {
        if (!angular.isObject(tabs)) {
            throw new Error("Invalid argument: an object expected");
        }
        tabs.$select = this.selectTab.bind(this);
        tabs.$getSelectedTab = function() {
            return this._selectedTab;
        }.bind(this);
        tabs.$getPrevSelectedTab = function() {
            return this._prevSelectedTab;
        }.bind(this);
        this._tabs = tabs;
        this._activeClass = activeClass || undefined;
        this._defaultSelected = angular.isDefined(defaultSelectedName)
            ? ('' + defaultSelectedName) : undefined;
        this._onTabSelectedFn = angular.isFunction(onTabSelected) ? onTabSelected : undefined;
        this.$timeout(function() {
            if (tabs.$onReady) {
                tabs.$onReady(tabs.$select);
            }
            tabs.$ready = true;
        }.bind(this));
    },

    getActiveClass: function() {
        return this._activeClass;
    },

    onTabSelected: function(fn) {
        this.$scope.$on(this.EVENT_BBW_TAB_SELECTED, fn);
    },

    addTab: function(name) {
        if (!this._tabs) {
            throw new Error("setup() must be called first");
        }
        name = '' + name;
        this._tabs[name] = false;
        if (this._defaultSelected === name) {
            this.selectTab(name);
        }
    },

    selectTab: function(name) {
        if (this._selectTab(name)) {
            this.$scope.$parent.$broadcast(this.EVENT_BBW_TAB_SELECTED, name);
            if (this._onTabSelectedFn) {
                this._onTabSelectedFn(name);
            }
        }
    },

    _selectTab: function(name) {
        var tabWasSelected = false;
        if (!this._tabs) {
            throw new Error("setup() must be called first");
        }
        for (var tabName in this._tabs) {
            if (this._tabs.hasOwnProperty(tabName) && tabName.substr(0, 1) !== '$') {
                if (name === tabName) {
                    if (!this._tabs[tabName]) {
                        this._tabs[tabName] = true;
                        tabWasSelected = true;
                        this._prevSelectedTab = this._selectedTab;
                        this._selectedTab = tabName;
                    }
                } else {
                    this._tabs[tabName] = false;
                }
            }
        }
        return tabWasSelected;
    }

});

bbw.directive.bbwTabs = [function() {

    return {
        restrict: 'A',
        scope: {
            bbwTabs: '=bbwTabs',
            bbwTabsActiveClass: '@bbwTabsActiveClass',
            bbwTabsDefault: '&bbwTabsDefault',
            bbwOnTabSelected: '=bbwOnTabSelected'
        },
        transclude: true,
        template: '<ng-transclude></ng-transclude>',
        controller: bbw.directive.BbwTabsController,
        link: {
            pre: function(scope, element, attrs, ctrl) {
                if (!angular.isObject(scope.bbwTabs)) {
                    scope.bbwTabs = {};
                }
                ctrl.setup(scope.bbwTabs, scope.bbwTabsActiveClass, scope.bbwTabsDefault(), scope.bbwOnTabSelected);
            },
            post: function(scope, element, attrs, ctrl) {
            }
        }
    };

}];

bbw.directive.bbwTab = ['$rootScope', function($rootScope) {

    return {
        restrict: 'A',
        require: '^bbwTabs',
        scope: {
            name: '&bbwTab'
        },
        link: function(scope, element, attrs, ctrl) {
            var name = scope.name();
            element.on(attrs.mobileTapHack ? 'mousedown' : 'click', function() {
                var cb = function() {
                    ctrl.selectTab(name);
                };
                if ($rootScope.$$phase) {
                    scope.$evalAsync(cb);
                } else {
                    scope.$apply(cb);
                }
            });
            ctrl.onTabSelected(function(event, selectedTabName) {
                var activeClass = ctrl.getActiveClass();
                if (activeClass) {
                    if (name === selectedTabName) {
                        element.addClass(activeClass);
                    } else {
                        element.removeClass(activeClass);
                    }
                }
            });
            ctrl.addTab(name);
        }
    };

}];
